import { Link } from 'react-router-dom';

const Hero = () => {
  const handleScrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-dark-blue via-dark-blue-light to-dark-blue-lighter text-white py-24 md:py-32 overflow-hidden">
      {/* Background image only on desktop to improve mobile LCP */}
      <div className="hidden md:block absolute inset-0 opacity-10">
        <img 
          src="/images/carl-raw-fzJPPfBhZ38-unsplash.webp" 
          alt="" 
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
          decoding="async"
          width="1920"
          height="1080"
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="flex items-center space-x-2 mb-4">
            <span className="text-accent-red text-2xl" aria-hidden="true">✨</span>
            <span className="text-accent-red font-semibold">Your Trusted UK Casino Guide</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Find Your Perfect Casino Match
            <span className="block text-accent-red mt-2">Spin Smart, Win Big</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 text-gray-300 leading-relaxed">
            We've handpicked the UK's most trusted online casinos. Compare bonuses, read expert reviews, and start playing with confidence. Your next big win starts here.
          </p>
          
          <div className="flex flex-wrap gap-3 mb-8">
            <a
              href="#offers"
              onClick={(e) => handleScrollToSection(e, 'offers')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              Offers
            </a>
            <a
              href="#about"
              onClick={(e) => handleScrollToSection(e, 'about')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              About
            </a>
            <a
              href="#guides"
              onClick={(e) => handleScrollToSection(e, 'guides')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              Guides
            </a>
            <a
              href="#faq"
              onClick={(e) => handleScrollToSection(e, 'faq')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              FAQ
            </a>
            <a
              href="#news"
              onClick={(e) => handleScrollToSection(e, 'news')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              News
            </a>
            <a
              href="#contact"
              onClick={(e) => handleScrollToSection(e, 'contact')}
              data-discover="true"
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-all border border-white border-opacity-30"
            >
              Contact
            </a>
          </div>
          
        
        </div>
      </div>
    </section>
  );
};

export default Hero;

